import React from 'react';
import { useHistory } from 'react-router-dom';
import './LegalUser.scss';
import ImageWebp from '../../../utils/imageProcess/ImageWebp';
import { connect } from 'react-redux';

const LegalUser = ({ user, browserLocation }) => {

  const history = useHistory();

  const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
  const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
  const firmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

  let defaultAvatar;
  if (
    user.role &&
    user.role === 'lawyer' ) {
    if (
      user.genero === 'male'
    ) {
      defaultAvatar = maleAvatar;
    } else {
      defaultAvatar = femaleAvatar;
    }
  } else {
    defaultAvatar = firmAvatar;
  }


  let fullName;
  if (user.role && user.role === 'lawFirm' && user.officeName && user.officeName !== '') {
    fullName = `${user.officeName}`
  } else if (user.name && user.firstLastName && user.secondLastName) {
    fullName = `${user.name} ${user.firstLastName} ${user.secondLastName}`
  } else if (user.name && user.firstLastName) {
    fullName = `${user.name} ${user.firstLastName}`
  } else if (user.name) {
    fullName = user.name
  }

  let location;
  if (user.sede && user.sede.length && user.sede.length !== 0) {
    let locationIndex = -1
    locationIndex = user.sede.findIndex(elem => {
      return elem.estado === browserLocation
    })
    if (locationIndex >= 0) {
      location = `${user.sede[locationIndex].estado ? user.sede[locationIndex].estado : ''}${user.sede[locationIndex].municipio ? `, ${user.sede[locationIndex].municipio}` : ''}`
    } else {
      location = `${user.sede[0].estado ? user.sede[0].estado : ''}${user.sede[0].municipio ? `, ${user.sede[0].municipio}` : ''}`
    }
  }

  let specialty;
  if (user.specialties && user.specialties.length && user.specialties.length !== 0) {
    specialty = user.specialties[0]
  }

  const getQualification = () => {
    let qualification;
    if (user.analytics && user.analytics.opinion && user.analytics.opinion.qualification) {
      qualification = Math.floor(user.analytics.opinion.qualification)
    }
    let result = []
    for (let i = 0; i < qualification; i++) {
      result.push(true)
    }
    return result
  }

  const handleClick = () => {
    history.push(`/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`, user)
  }

  return (
    <div className="legalPerson_card" onClick={handleClick}>
      <figure className="legalPerson_card_image">
        {/* <span>PLUS</span> */}
        <ImageWebp
          srcWebp={user.imageWebp}
          alt={fullName}
          src={
            user.image ? user.image :
            user.imgProfile ? user.imgProfile :
            defaultAvatar
          }
        />
      </figure>
      <div className="legalPerson_card_info">
        <h5 className="legalPerson_name">
          {fullName}
        </h5>
        <div>
          <h6 className="legalPerson_specialty">
            {specialty}
          </h6>
        </div>
        <span className="legalPerson_location">{location}</span>
        <div className="legalPerson_stars">
          {getQualification().map(() => {
            return (
              <figure>
                <img
                  src="/img/LandingClient/CardTop/star-yellow.svg"
                  alt="Calificación"
                />
              </figure>
            )
          })}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  browserLocation: state.userState.browserLocation,
})

export default connect(mapStateToProps)(LegalUser);
